module.exports = __webpack_public_path__ + "img/move.6d4dde27.svg";